import { NgModule } from '@angular/core';
import { SharedModule as AppSharedModule } from '@shared/shared.module';
import { CalculationFormModule } from '@client/shared/components/calculation-form/calculation-form.module';
import { MetricModule } from '@client/shared/components/metric/metric.module';
import { LoanModule } from '@client/shared/components/loan/loan.module';
import { TaxSummaryModule } from '@client/shared/components/tax-summary/tax-summary.module';
import { ImpersonatorModule } from '@client/shared/components/impersonator/impersonator.module';
import { YearChooserModule } from '@client/shared/components/year-chooser/year-chooser.module';
import { FriendInviteModule } from '@client/shared/components/friend-invite/friend-invite.module';
import { SubscriptionReminderModule } from '@client/shared/components/subscription-reminder/subscription-reminder.module';
import { ChartAccountsModule } from '@client/shared/components/chart-accounts/chart-accounts.module';
import { YoutubePreviewComponent } from '@client/shared/components/youtube-preview/youtube-preview.component';

@NgModule({
  imports: [
    AppSharedModule,
    CalculationFormModule,
    MetricModule,
    LoanModule,
    TaxSummaryModule,
    ImpersonatorModule,
    YearChooserModule,
    FriendInviteModule,
    SubscriptionReminderModule,
    ChartAccountsModule,
    YoutubePreviewComponent
  ],
  exports: [
    AppSharedModule,
    CalculationFormModule,
    MetricModule,
    LoanModule,
    TaxSummaryModule,
    ImpersonatorModule,
    YearChooserModule,
    FriendInviteModule,
    SubscriptionReminderModule,
    ChartAccountsModule,
    YoutubePreviewComponent
  ],
})
export class SharedModule {
}
